.altSkuField {
  margin: 0;
  line-height: 2rem;
  font-size: 1.6rem;
  text-align: left;
  word-break: break-word;
  color: var(--color-white);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
